import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PersonasComponent } from './pages/personas/personas.component';
import {ApiService} from './services/api.service';
import {ApiResource} from './resources/api.resource';


import { RECAPTCHA_SETTINGS, RecaptchaSettings, RecaptchaModule } from 'ng-recaptcha'

import { BuscarComponent } from './components/buscar/buscar.component';
import {FilterPipe} from './pipes/filter.pipe';
import { EmpresasComponent } from './pages/empresas/empresas.component';
import { SegurosPersonasComponent } from './pages/seguros-personas/seguros-personas.component';
import { SegurosEmpresasComponent } from './pages/seguros-empresas/seguros-empresas.component';
import { EmpresasHeaderComponent } from './components/empresas-header/empresas-header.component';
import { PersonasHeaderComponent } from './components/personas-header/personas-header.component';
import { SegurosEmpresasHeaderComponent } from './components/seguros-empresas-header/seguros-empresas-header.component';
import { SegurosPersonasHeaderComponent } from './components/seguros-personas-header/seguros-personas-header.component';
import { FooterComponent} from './components/footer/footer.component';
import { SlidesComponent } from './components/slides/slides.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { ProductsComponent } from './components/products/products.component';
import { CustomComponent } from './components/custom/custom.component';
import { ActivosDetalleComponent } from './components/activos-detalle/activos-detalle.component';
import { ActivosEmailComponent } from './components/activos-email/activos-email.component';
import { AgmCoreModule } from '@agm/core';
import { DocumentosOnbaseComponent } from './components/documentos-onbase/documentos-onbase.component';
import { ApiMbaasService } from './services/api-mbaas.service';
import { MbaasComponent } from './pages/mbaas/mbaas.component';
import { SolucionesDaviviendaComponent } from './components/soluciones-davivienda/soluciones-davivienda.component';
import { PromocionesComponent } from './components/promociones/promociones.component';
import { BancaEnLineaComponent } from './components/banca-en-linea/banca-en-linea.component';
import { InformacionBancaComponent } from './pages/informacion-banca/informacion-banca.component';
import { PaginaMantenimientoComponent } from './components/pagina-mantenimiento/pagina-mantenimiento.component';


@Pipe({name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}

  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

@NgModule({
  declarations: [
    FilterPipe,
    AppComponent,
    PersonasComponent,
    BuscarComponent,
    EmpresasComponent,
    SegurosPersonasComponent,
    SegurosEmpresasComponent,
    PersonasHeaderComponent,
    FooterComponent,
    SlidesComponent,
    TabsComponent,
    ProductsComponent,
    CustomComponent,
    EmpresasHeaderComponent,
    SegurosEmpresasHeaderComponent,
    SegurosPersonasHeaderComponent,
    SafeHtmlPipe,
    ActivosDetalleComponent,
    ActivosEmailComponent,
    DocumentosOnbaseComponent,
    MbaasComponent,
    SolucionesDaviviendaComponent,
    PromocionesComponent,
    BancaEnLineaComponent,
    InformacionBancaComponent,
    PaginaMantenimientoComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    RecaptchaModule.forRoot(),
    AgmCoreModule.forRoot({ 
      apiKey: 'AIzaSyA8arECFJRqAAgZ0m403F1cQNMSjsAhNPM'
    })
  ],
  providers: [
    ApiService,
    ApiResource,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: { siteKey: '6LdO82oUAAAAABFtuKZSb-BI050Mq0iub6QGrS8A' } as RecaptchaSettings,
    },
    ApiMbaasService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
